import React from "react";
import { CBadge } from "@coreui/react";

import { getJobTypeLabel } from "@src/utils/formatters";

/**
 * Job type color mapping - shared across all pages displaying job types
 */
const JOB_TYPE_COLORS: Record<string, string> = {
  backtest: "info",
  live: "success",
  optimization: "warning",
  cache: "secondary",
  walk_forward: "primary",
  monte_carlo: "dark",
};

interface Props {
  jobType: string;
}

/**
 * Renders a CoreUI badge for job type with appropriate color.
 */
export const JobTypeBadge: React.FC<Props> = ({ jobType }) => {
  const color = JOB_TYPE_COLORS[jobType] || "secondary";

  return <CBadge color={color}>{getJobTypeLabel(jobType).toUpperCase()}</CBadge>;
};
